import React from "react";
import style from './ErrorBoundary.module.css';
import * as Sentry from "@sentry/react";

export interface ErrorBoundaryProps {
    children: React.ReactNode;
    fallback?: React.ReactNode;
}
export interface ErrorBoundaryState {
    hasError: boolean;
    message: string;
}

class ErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
    state = {
        message: '',
        hasError: false
    };
    constructor(props: ErrorBoundaryProps) {
        super(props);
        this.state = { hasError: false, message: ''};
    }

    static getDerivedStateFromError(error: Error): Partial<ErrorBoundaryState> {
        // Update state so the next render will show the fallback UI.
        return { hasError: true, message: error.message };
    }

    componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
        // You can also log the error to an error reporting service
        if(parseInt(import.meta.env.VITE_REPORT_ERRORS) > 0) {
            Sentry.captureException(error, {
                extra: {
                    errorInfo
                }
            });
        }
    }

    render() {
        if (this.state.hasError) {
            // You can render any custom fallback UI
            if(this.props.fallback) {
                return this.props.fallback;
            }
            if(this.state.message !== '') {
                return <div className={style.error}>An error occurred: {this.state.message}</div>
            } else {
                return <div className={style.error}>An unknown error occurred</div>;
            }
        }

        return this.props.children;
    }
}

export default ErrorBoundary;
